import React from 'react';
import { GridTable, GridController } from '@ctsu/ctsu-mui-grid';
import { compose } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import PropTypes from 'prop-types';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { AffiliationsHistoryColumns } from '../gridcolumns';

const controller = GridController.createController();
const AffiliationsHistoryCmp = (props) => {
    const {tagId, historyData} = props;
  return (
      <GridTable
        tag={`${TE.ID}${tagId}${TE.TABLE}`}
        title="Affiliations & Verifications"
        exportTitle={`Affiliations & Verifications-${useGetPathProtocol()}-PSR-HISTORY`}
        user={GetUserFullName()}
        columns={AffiliationsHistoryColumns}
        rows={historyData}
        controller={controller}
        filterable
        sortable
        toPdf={false}
      />
  );
};

const AffiliationsHistory = compose(
  withAppContext
)(AffiliationsHistoryCmp);

AffiliationsHistory.propTypes = {
  psrId: PropTypes.number
};

AffiliationsHistory.defaultProps = {
  psrId: null
};

export { AffiliationsHistory };
